import React, { useState, useEffect, useContext } from 'react';
import { capitalizeWords, checkIfEmpty }                        from 'functions/functions';
import { toast }                  from 'react-toastify';
import { getAllOutStandingKeys, addNote, getOutstandingKeysForMultipleBuildings }                  from '../../services/keyServices';
import UserContext                                from '../../contexts/userContext';
import location_icon                              from '../../images/location-pin.png';
import { showSuccessToast } from 'utils/toasts';

const useGlobalOutstandingKeys = () => {

    const [data, setData]                           = useState([]);
    const [modalData, setModalData]                 = useState([]);
    const [searchValue, setSearchValue]             = useState('');
    const [selectedBuilding, setSelectedBuilding]   = useState('all');
    const [noteValue, setNoteValue]                 = useState('');
    const [modalIsOpen, setModalIsOpen]             = useState(false);
    const [loading, setLoading]                     = useState(true);
    const [buildingOptions, setBuildingOptions]     = useState([]);
    
    const {user} = useContext(UserContext);

    
    const header = [
        {label : "Building",      key : "buildingName"},
        {label : "Tag Name",      key : "tag"},
        {label : "Key No.",       key : "keyNumber"},
        {label : "Visitor Name",  key : "visitorName"},
        {label : "Company",       key : "visitorCompany"},
        {label : "Email",         key : "visitorEmail"},
        {label : "Phone No.",     key : "visitorPhone"},
        {label : "Issue Time",    key : "issueTime"},
    ];
    
    const columns = [
        {name: 'Building', selector: row => capitalizeWords(row.buildingName ?row.buildingName : "N/A"),},
        {
        name: "Key",
            cell: (row) => (
                <div onClick={() => rowClick(row)}>
                {capitalizeWords(row.tag)}
                <span style={{ color: "grey" }}>
                    ({capitalizeWords(row.keyNumber)})
                </span>
                </div>
            ),
        },
        {name: 'Visitor Name', selector: row => capitalizeWords(row.visitorName),},
        {name : "Company", selector : row => capitalizeWords(row.visitorCompany)},
        
        {name : "Email", selector : row => row.visitorEmail},
        {name : "Phone No.", selector : row => row.visitorPhone},
        {name : "Issue Time", selector : row => row.issueTime},
        {name : "Location", button : true, cell : (row) => (
            <img className='location-pin' src={location_icon} onClick={()=> onLocationClick(row.location)} />
        )}
    ];
    
    const onLocationClick = (location) => {
      if(location[0] && location[1]) window.open(`https://maps.google.com?q=${location[0]},${location[1]}`, '_blank', 'noreferrer');
      else toast.error("No Location Details");
    }
    
    useEffect(() => {
        
        fetchGlobalOutStandingKeys();
        
    }, [])


    const fetchGlobalOutStandingKeys = async () => {
        try {
            setLoading(true);

            const response = await getOutstandingKeysForMultipleBuildings(
                user.approvedBuildings
            );

            setData(response.result);

            let buildingOptions = [{
                label: "All Buildings",
                value: "all"
            }];

            Object.entries(response.buildingMap).map(([buildingId, buildingName]) => {
                buildingOptions.push({
                    label: buildingName,
                    value: buildingId
                });
            });
            setBuildingOptions(buildingOptions);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const onSearchValueChanges = (e) => {
      setSearchValue(e.target.value);
    }

    const rowClick = (e) => {
      setModalData(e);
      setModalIsOpen(true);
    }

    const closeModal = () => {
      setModalIsOpen(false);
    }

    const addNoteValue = async (e) => {
      e.preventDefault();
      let errorStatusObj = {};
      let errorMessageObj = {};

      if(checkIfEmpty(noteValue)) {
        errorStatusObj.note = true;
        errorMessageObj.note = 'Please enter note'
      }

      if(!errorStatusObj.note) {
        const response = await addNote(modalData.id, noteValue, modalData.notes);
        if(response.status) {
          await fetchGlobalOutStandingKeys();
          showSuccessToast('Note Added');
          setNoteValue('');
        }
      }
    }

    return {
        data, 
        searchValue, onSearchValueChanges, setSearchValue, onLocationClick,
        columns, header,
        loading,
        rowClick, modalIsOpen, closeModal, modalData,
        noteValue, setNoteValue, addNoteValue,
        selectedBuilding, setSelectedBuilding,
        buildingOptions
    }
}

export default useGlobalOutstandingKeys